import React from "react";
import { DeliverySummary as DeliverySummaryType, } from "./dashboardType";


interface Props {
  data: DeliverySummaryType;
}

const DeliverySummary: React.FC<Props> = ({
  data,
}) => {
  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Delivery Operations
      </h2>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
        <div className="rounded-lg bg-gray-50 p-4">
          <p className="font-medium">
            Pickup
          </p>

          <p className="mt-2 text-sm">
            Total:{" "}
            <strong>
              {data.Pickup.Total}
            </strong>
          </p>

          <p className="text-sm">
            Completed:{" "}
            <strong>
              {data.Pickup.Completed}
            </strong>
          </p>

          <p className="text-sm">
            Pending:{" "}
            <strong>
              {data.Pickup.Pending}
            </strong>
          </p>
        </div>

        <div className="rounded-lg bg-gray-50 p-4">
          <p className="font-medium">
            Delivery
          </p>

          <p className="mt-2 text-sm">
            Total:{" "}
            <strong>
              {data.Delivery.Total}
            </strong>
          </p>

          <p className="text-sm">
            Delivered:{" "}
            <strong>
              {data.Delivery.Delivered}
            </strong>
          </p>

          <p className="text-sm">
            Pending:{" "}
            <strong>
              {data.Delivery.Pending}
            </strong>
          </p>
        </div>

        <div className="rounded-lg bg-gray-50 p-4">
          <p className="font-medium">
            Lunch
          </p>

          <p className="mt-2 text-sm">
            Total:{" "}
            <strong>
              {data.Lunch.Total}
            </strong>
          </p>

          <p className="text-sm">
            Ready:{" "}
            <strong>
              {data.Lunch.Ready}
            </strong>
          </p>
        </div>

        <div className="rounded-lg bg-gray-50 p-4">
          <p className="font-medium">
            Live Users
          </p>

          <p className="mt-2 text-3xl font-bold">
            {data.Live_Users}
          </p>
        </div>
      </div>
    </section>
  );
};

export default DeliverySummary;